import type {
    Banner,
    ColorVariation,
    Product,
    ProductComparisonBanner,
    SearchContext,
    SimilarProductHeader,
    Slider,
    Variation,
} from '@shared/types/types.ts';
import type { BrandTileCampaign } from '@tilelist/domain/feature-visibility/BrandTile.ts';

export type SponsoredDisplayAd = {
    type: 'SponsoredDisplayAd';
    searchContext?: SearchContext;
    /*                                                                                                              */
    hidden?: true;
};

export type BrandItem = {
    type: 'BrandTile';
    product: { id: string };
    campaign: BrandTileCampaign;
    localListPosition: number;
    actualListPosition: number;
};

export type TileItem = ProductItem | BrandItem;

export type ProductItem = {
    product: Product;
    variations: Variation[];
    localListPosition: number;
    actualListPosition: number;
    originPosition: number;
    colors?: ColorVariation[];
    currentVariationId?: Variation['variationId'];
    /*                                                                                      */
    variationLoadFailed?: boolean;
    type: 'AS' | 'BOOSTED';
};

export type BenefitCinemaItem = {
    type: 'BenefitCinema';
};

export type TileListItem =
    | SimilarProductHeader
    | Banner
    | Slider
    | ProductComparisonBanner
    | ProductItem
    | SponsoredDisplayAd
    | BrandItem
    | BenefitCinemaItem;

export function isProductItem(item: TileListItem): item is ProductItem {
    return ['AS', 'BOOSTED'].includes(item.type);
}
